// src/components/BuyModal.js
import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useLanguage } from '../contexts/LanguageContext';
import { db } from '../firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

export default function BuyModal({ onClose }) {
    const { user } = useAuth();
    const { t } = useLanguage();
    const [paymentCode, setPaymentCode] = useState('');
    const [loading, setLoading] = useState(false);

    const generatePaymentCode = () => {
        return Math.floor(100000 + Math.random() * 900000).toString();
    };

    const handleBuyAttempts = async (amount, price) => {
        setLoading(true);
        const code = generatePaymentCode();
        setPaymentCode(code);

        try {
            // Save pending payment
            await addDoc(collection(db, 'pendingPayments'), {
                userId: user.uid,
                userEmail: user.email,
                code: code,
                amount: amount,
                price: price,
                createdAt: serverTimestamp(),
                approved: false
            });
        } catch (error) {
            console.error("Error creating payment:", error);
            alert("Greška pri kreiranju uplate. Pokušajte ponovo.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white text-gray-900 p-6 rounded-lg max-w-md w-full">
                <h3 className="text-xl font-bold mb-4">{t('buyAttempts')}</h3>

                {!paymentCode ? (
                    <div className="space-y-3">
                        <button
                            onClick={() => handleBuyAttempts(100, 100)}
                            className="w-full p-3 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors disabled:bg-gray-400"
                            disabled={loading}
                        >
                            {t('option1')}
                        </button>

                        <button
                            onClick={() => handleBuyAttempts(1100, 1000)}
                            className="w-full p-3 bg-purple-600 text-white rounded hover:bg-purple-700 transition-colors disabled:bg-gray-400"
                            disabled={loading}
                        >
                            {t('option2')}
                        </button>
                    </div>
                ) : (
                    <div className="space-y-4">
                        <div className="p-4 bg-gray-100 rounded">
                            <p className="font-semibold text-lg mb-2">{t('paymentCode')}:</p>
                            <p className="text-2xl font-mono text-center bg-white p-2 rounded">{paymentCode}</p>
                        </div>

                        <div className="p-4 bg-blue-50 rounded">
                            <p></p>
                            <p className="text-sm mb-1">{t('paymentInstructions')}</p>
                            <p className="text-sm font-semibold">{t('paymentNote')}: {paymentCode}</p>
                        </div>

                        <div className="text-sm text-gray-600">
                            <p>Nakon uplate, vaši pokušaji će biti dodati čim administrator odobri uplatu.</p>
                        </div>
                    </div>
                )}

                <button
                    onClick={() => {
                        onClose();
                        setPaymentCode('');
                    }}
                    className="mt-4 w-full p-2 bg-gray-300 rounded hover:bg-gray-400 transition-colors"
                >
                    {t('close')}
                </button>
            </div>
        </div>
    );
}